import styles from "./Styles/Auth.module.css"
import authImage from "../Assets/authImage.png"
import Input from "../Components/Input"
import {BsEyeSlashFill,BsEyeFill} from "react-icons/bs"
import Button from "../Components/Button"
import React, { useState } from "react"
import GButton from "../Components/GButton"
import { useNavigate } from "react-router-dom"

function SignUp() {

    const [passwordVisible, setPasswordVisible] = useState(false)
    const [createPassword, setCreatePassword] = useState(false)
    const navigate = useNavigate()

    const [data, setData] = useState({
        name: '',
        email: '',
        password: ''
    })

    return <div className={styles.container}>
       
        <div className={styles.authForm}>
            <form>
                {!createPassword ? <h2>Login</h2> : <h2>Create A Password</h2>} 
                {!createPassword && <Input label="Email Address/Mob Number" onChange={(e)=>setData({...data,email:e.target.value})} value={data.email} mb={24} type="email"/>}

                {createPassword && <React.Fragment>
                    <Input label="New Password" mb={24} type="password" />
                    <Input label="Confirm Password" mb={20} type="password" />
                </React.Fragment>}

                {!createPassword && <Button height={50} radius={10} onClickHandler={()=>setCreatePassword(true)} title="Continue" />}
                {createPassword && <Button height={50} radius={10} onClickHandler={null} title="Set Password" />}

                <div className={styles.orSeparator}>
                    <p>or</p>
                </div>

                <GButton title="Login with Google" onClickHandler={(e)=>e.preventDefault()} />
            </form>
        </div>

        <div className={styles.authImage}>
            <img src={authImage} />
        </div>
    </div>
}

export default SignUp